export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`} aria-label="Velvet Signal">
      <span className="brand__mark" aria-hidden="true">
        <i />
        <i />
      </span>
      <span>VELVET SIGNAL</span>
    </div>
  );
}
